import { useQuery } from '@tanstack/react-query';
import {
  fetchInstallationQualification,
  fetchInstallationQualificationAccounts,
  fetchInstallationQualifications,
} from './api';
import type { InstallationQualificationsFilters } from './types';

export const installationQualificationKeys = {
  all: ['installation-qualifications'] as const,
  lists: () => [...installationQualificationKeys.all, 'list'] as const,
  list: (filters: InstallationQualificationsFilters) => [...installationQualificationKeys.lists(), filters] as const,
  details: () => [...installationQualificationKeys.all, 'detail'] as const,
  detail: (id: string) => [...installationQualificationKeys.details(), id] as const,
  accounts: () => [...installationQualificationKeys.all, 'accounts'] as const,
};

export function useInstallationQualifications(filters: InstallationQualificationsFilters) {
  return useQuery({
    queryKey: installationQualificationKeys.list(filters),
    queryFn: () => fetchInstallationQualifications(filters),
  });
}

export function useInstallationQualification(id: string | undefined) {
  return useQuery({
    queryKey: installationQualificationKeys.detail(id || ''),
    queryFn: () => fetchInstallationQualification(id!),
    enabled: !!id,
  });
}

export function useInstallationQualificationAccounts() {
  return useQuery({
    queryKey: installationQualificationKeys.accounts(),
    queryFn: fetchInstallationQualificationAccounts,
    staleTime: 5 * 60 * 1000,
  });
}
